/** 读取 TanStack Router search 中的非空字符串，避免各页面重复宽松类型判断。 */
export function readSearchString(value: unknown) {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim() : undefined
}

/** 生成仅用于前端 optimistic UI 的本地 id，不作为后端消息或会话标识持久化。 */
export function createLocalMessageId(prefix: string) {
  return `${prefix}-${Date.now().toString()}-${Math.random().toString(16).slice(2)}`
}
